import { FC, ReactElement } from 'react'

import FindMySchoolForm from '../../components/findMySchool/findMySchoolForm'
import Page from '../../components/page'
import { ASSETS } from '../../constants'
import { useI18n } from '../../hooks'
import FindMySchoolPageTopBanner from './findMySchoolPageTopBanner'

import './index.css'

const FindMySchoolPage: FC = (): ReactElement => {
  const { t } = useI18n()
  return (
    <Page
      metaData={{ title: t('School_findMySchool_meta_title'), description: t('School_findMySchool_description'), charset: 'utf-8' }}
      className="find-my-school-page"
    >
      <section className="find-my-school-page-section find-my-school-page-top-banner-section">
        <FindMySchoolPageTopBanner
          title={t('About_findMySchool').toLowerCase()}
          description={[`${t('School_findMySchoolPageTopBannerDescription1')}`, `${t('School_findMySchoolPageTopBannerDescription2')}`]}
          parallax={{
            classNames: { banner: `parallax-container-custom`, img: 'parallax-img-custom' },
            bgPosition: 'center',
            imgData: { src: `${ASSETS}/banners/find-your-school/find_your_school_desktop.jpg`, alt: 'find-my-school-banner' },
            isStatic: true,
          }}
        />
      </section>
      <section className="find-my-school-page-section find-my-school-page-main-section">
        <FindMySchoolForm />
      </section>
    </Page>
  )
}

export default FindMySchoolPage
